export const licenseActions = {
    UPLOAD_LICENSE: 'UPLOAD_LICENSE',
    GET_CURRENT_LICENSE: 'GET_CURRENT_LICENSE',
    SET_CURRENT_LICENSE: 'SET_CURRENT_LICENSE',
    SET_LICENSE_WARNING: 'SET_LICENSE_WARNING',
    SET_LICENSE_IGNORE_WARNINGS: 'SET_LICENSE_IGNORE_WARNINGS',
    GET_LICENSE_WARNINGS:'GET_LICENSE_WARNINGS',
    SET_LICENSE_WARNINGS:'SET_LICENSE_WARNINGS'
};

const initState = {};

export const licenseReducer = (state = initState, action: any) => {
    switch (action.type) {
        case licenseActions.SET_LICENSE_WARNINGS:
                return { ...state, warningText: action.payload}
        case licenseActions.SET_CURRENT_LICENSE:
            return { ...state, ...action.payload }
        case licenseActions.SET_LICENSE_WARNING:           
           return { ...state, warningText: action.payload.warningText}
        case licenseActions.SET_LICENSE_IGNORE_WARNINGS:           
            return { ...state, ignoreWarningText: action.payload.ignoreWarningText}

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/licenseReducer.ts